// hooks/useTokenRefresh.js
import { useEffect } from 'react';
import { checkForTokenExpirationAndRefresh } from '../lib/cognitoutils'; // Import your function

const useTokenRefresh = () => {
  useEffect(() => {
    checkForTokenExpirationAndRefresh();
  }, []);
};

export default useTokenRefresh;